import { Link } from 'react-router-dom';
import { formatDisplayDate, type PageDates } from '../data/content-dates';

interface BylineProps {
  dates: PageDates;
  className?: string;
}

// The company is the author, not a person. The date is the one the page's
// JSON-LD dateModified and its sitemap <lastmod> carry (content-dates.ts).
export default function Byline({ dates, className = '' }: BylineProps) {
  return (
    <p className={`text-sm text-white/55 ${className}`}>
      By{' '}
      <Link to="/about" className="text-white/70 hover:text-white underline underline-offset-4 decoration-white/20 transition-colors">
        Eclipse Group
      </Link>
      <span aria-hidden="true"> · </span>
      Updated <time dateTime={dates.modified}>{formatDisplayDate(dates.modified)}</time>
    </p>
  );
}
